import { Component, input } from '@angular/core';
import { formatPatientName } from '@insolution/core-utils';
import { Patient } from '@insolution/graphql-data-access';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'lib-personal-data-limited',
  imports: [TranslatePipe],
  templateUrl: './personal-data-limited.html',
  styleUrl: './personal-data-limited.scss',
})
export class PersonalDataLimited {
  public patient = input.required<Patient>();

  protected formatPatientName = formatPatientName;
}
